<template>
  <div class="orders">
    <Loading v-if="loading" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Loading from "@/components/shared/Loading.vue";

export default {
  data() {
    return {
      loading: true,
    };
  },
  components: { Loading },
  computed: {
    ...mapGetters(["user_details", "account_details"]),
  },
  mounted() {
    // wait for user details to exist before routing
    this.waitThenRoute();
  },
  methods: {
    waitThenRoute() {
      if (this.user_details.account_id) {
        //variable exists, stop waiting
        // this is probably an abuse of the router, but . . .
        if (this.user_details.super_admin || this.user_details.admin) {
          this.$router.replace({
            name: "account-orders",
            params: { account_id: this.user_details.account_id },
          });
        } else if (
          this.user_details.support_accounts &&
          this.user_details.support_accounts.length > 0
        ) {
          this.$router.replace({
            name: "account-orders",
            params: { account_id: this.user_details.support_accounts[0] },
          });
        } else {
          this.$router.replace({
            name: "my-orders",
            params: { account_id: this.user_details.account_id },
            query: {
              start_date: this.$route.query.start_date || "",
              end_date: this.$route.query.end_date || "",
              filters: [`user_id:${this.user_details.user_id}`],
            },
          });
        }
      } else {
        setTimeout(this.waitThenRoute, 200);
      }
    },
  },
};
</script>
